<template>
  <div class="ml-2 ml-md-5 ml-sm-2 mr-4 pb-3">
    <div class="row mt-3">
      <div class="col col-sm col-12 pt-2">
        <em class="fas fa-info-circle text-orange mr-1" />
        <span class="color-gray-7 font-16 font-weight-bold">
          Información de Año Escolar Extendido
        </span>
      </div>
    </div>
    <div class="row py-3 mr-md-0">
      <div class="col-12 col-md-6">
        <span class="color-gray-6 d-block font-14">Fecha de Solicitud:</span>
        <span class="font-16 color-black">
          {{ requestDate | date }}
        </span>
      </div>
      <div class="col-12 col-md-6">
        <span class="color-gray-6 d-block font-14">Número de Solicitud:</span>
        <span class="font-16 color-black">
          {{ requestNumber | empty }}
        </span>
      </div>
      <div class="col-12">
        <span class="color-gray-6 d-block font-14 mt-3">Observación:</span>
        <span class="font-16 color-black">
          {{ comments | empty }}
        </span>
      </div>
      <div class="col-12">
        <section class="pt-5">
          <section-title :has-line="true" title="Documentos Añadidos" />
        </section>
      </div>
      <div class="col-12">
        <custom-result-not-found
          v-if="aeeDocuments.length === 0"
          text="No cuenta con documentos en el sistema."
        />
        <div
          v-for="(item, index) in aeeDocuments"
          :key="`${index}-${item.documentId}`"
          class="col-12 col-md-12"
        >
          <custom-callout
            class-main="mt-3"
            :has-border="true"
            :has-gradient="false"
            :has-toggle="false"
          >
            <div class="row mr-md-0 ml-n0 ml-md-n4 ml-0">
              <div class="col-12 col-md-6 my-2">
                <div class="color-gray-6 font-14">Documento:</div>
                <div class="color-black font-16">
                  {{ item.documentTypeName | empty }}
                </div>
              </div>
              <div class="col-12 col-md-3 my-2">
                <div class="color-gray-6 font-14">Archivo:</div>
                <div class="color-black font-16">
                  {{ item.filename | empty }}
                </div>
              </div>
              <div class="col-12 col-md text-sm-right mt-3 mt-sm-1">
                <action-button
                  id="btn-download-document"
                  class="btn-action-size"
                  :disabled="!item.documentId"
                  i="fas fa-file-download"
                  variant="success"
                  @click="() => onDownloadFileHandler(item)"
                />
              </div>
            </div>
          </custom-callout>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//constants
import SectionTitle from 'SectionTitle';
import CustomResultNotFound from 'custom-result-not-found';
import ActionButton from 'ActionButton';
import { downloadDocumentByAttachmentId as _downloadDocumentByAttachmentId } from '@/services/common/document.api.js';
import CustomCallout from 'custom-callout';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin';

export default {
  name: 'ContractAee',
  components: {
    CustomCallout,
    SectionTitle,
    ActionButton,
    CustomResultNotFound,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      model: {},
      editingDate: false,
    };
  },
  mixins: [alertMixin],
  computed: {
    requestNumber() {
      return this.data.requestAee.requestNumber;
    },
    createdDate() {
      return this.data.requestAee.createdDate;
    },
    requestDate() {
      return this.data.requestAee.requestDate || this.createdDate;
    },
    comments() {
      return this.data.requestAee.comments;
    },
    aeeDocuments() {
      return this.data.requestAee.documents;
    },
  },
  methods: {
    onDownloadFileHandler({ documentId }) {
      if (documentId) {
        _downloadDocumentByAttachmentId(documentId).catch((err) => {
          this.ShowToast(
            'Alerta',
            err.response.data.message || 'error',
            'error'
          );
        });
      }
    },
  },
};
</script>

<style lang="scss"></style>
